class ShowMoreText extends HTMLElement {
  constructor() {
    super();
    this.elements = {};
    this.isExpanded = false;
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  init() {
    try {
      this.elements = {
        full: this.querySelector('[data-full-description]'),
        truncated: this.querySelector('[data-truncated-description]'),
        readMoreBtn: this.querySelector('[data-read-more-btn]'),
        readLessBtn: this.querySelector('[data-read-less-btn]')
      };

      if (!this.elements.full || !this.elements.truncated || !this.elements.readMoreBtn) {
        return;
      }

      const charLimit = parseInt(this.getAttribute('data-char-limit')) || 200;
      const fullTextLength = this.elements.full.textContent.trim().length;
      const needsTruncation = fullTextLength > charLimit;
      
      if (!needsTruncation) {
        this.elements.readMoreBtn.style.display = 'none';
        this.elements.full.classList.add('active');
        this.elements.truncated.classList.remove('active');
        return;
      }

      // Use a pre-rendered read-less button if one exists in the markup,
      // otherwise create one and append it to the last paragraph.
      if (this.elements.readLessBtn) {
        this.elements.readLessBtn.addEventListener('click', this.handleToggle);
      } else {
        this.createReadLessButton();
      }

      this.elements.readMoreBtn.addEventListener('click', this.handleToggle);
      this.setInitialState();
      
    } catch (error) {
      console.error('ShowMoreText initialization error:', error);
    }
  }

  createReadLessButton() {
    // Find the last paragraph in the full content
    const lastParagraph = this.elements.full.querySelector('p:last-child');
    if (lastParagraph) {
      // Create the read less button
      this.elements.readLessBtn = document.createElement('button');
      this.elements.readLessBtn.type = 'button';
      this.elements.readLessBtn.setAttribute('data-read-trigger', '');
      this.elements.readLessBtn.setAttribute('data-read-more', this.elements.readMoreBtn.getAttribute('data-read-more'));
      this.elements.readLessBtn.setAttribute('data-read-less', this.elements.readMoreBtn.getAttribute('data-read-less'));
      this.elements.readLessBtn.setAttribute('data-read-less-btn', '');
      this.elements.readLessBtn.className = 'inline-read-less-btn';
      this.elements.readLessBtn.style.display = 'none';
      this.elements.readLessBtn.textContent = this.elements.readMoreBtn.getAttribute('data-read-less');
      
      // Add event listener
      this.elements.readLessBtn.addEventListener('click', this.handleToggle);
      
      // Insert the button at the end of the last paragraph
      lastParagraph.appendChild(this.elements.readLessBtn);
    }
  }

  setInitialState() {
    this.elements.truncated.classList.add('active');
    this.elements.full.classList.remove('active');
    this.elements.readMoreBtn.style.display = 'inline';
    if (this.elements.readLessBtn) {
      this.elements.readLessBtn.style.display = 'none';
    }
    this.isExpanded = false;
  }

  handleToggle(event) {
    event.preventDefault();
    
    try {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.elements.full.classList.add('active');
        this.elements.truncated.classList.remove('active');
        this.elements.readMoreBtn.style.display = 'none';
        if (this.elements.readLessBtn) {
          this.elements.readLessBtn.style.display = 'inline';
        }
      } else {
        this.elements.full.classList.remove('active');
        this.elements.truncated.classList.add('active');
        this.elements.readMoreBtn.style.display = 'inline';
        if (this.elements.readLessBtn) {
          this.elements.readLessBtn.style.display = 'none';
        }
      }
      
    } catch (error) {
      console.error('ShowMoreText toggle error:', error);
    }
  }

  disconnectedCallback() {
    if (this.elements.readMoreBtn) {
      this.elements.readMoreBtn.removeEventListener('click', this.handleToggle);
    }
    if (this.elements.readLessBtn) {
      this.elements.readLessBtn.removeEventListener('click', this.handleToggle);
    }
  }
}

if (!customElements.get('show-more-text')) {
  customElements.define('show-more-text', ShowMoreText);
}